<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <router-link
                class="btn btn-sm btn-outline-info"
                :to="{ name: 'inventario-salida_inventario' }"
              >
                <i class="fas fa-angle-double-left"></i>
                Atras
              </router-link>
              <form @submit="guardar">
                <h5 class="form-header">
                  Salida inventario #
                  <u>{{ current.numero }}</u>
                  &nbsp;
                  <div
                    class="badge"
                    :class="{
                      'badge-success': current.estado == 'A',
                      'badge-warning': current.estado == 'B',
                      'badge-danger': current.estado == '9',
                    }"
                  >
                    <i class="os-icon os-icon-ui-09"></i>
                    <span v-if="current.estado_str">{{
                      current.estado_str
                    }}</span>
                    <span v-if="!current.estado_str">En Proceso</span>
                  </div>
                  <div class="st-meta float-right">
                    <div class="element-actions">
                      <button
                        :disabled="current.estado == 'A'"
                        class="btn btn-outline-dark"
                        @click="imprimir"
                        type="button"
                      >
                        <i class="fa fa-print"></i>
                        Imprimir
                      </button>
                      &nbsp;
                      <div class="btn-group">
                        <button
                          :disabled="!current.id"
                          aria-expanded="false"
                          aria-haspopup="true"
                          class="btn btn-secondary dropdown-toggle"
                          data-toggle="dropdown"
                          type="button"
                        >
                          <i class="fa fa-cogs"></i>
                          Acciones
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <button
                            class="dropdown-item"
                            type="button"
                            @click="cerrar"
                            :disabled="!(current.estado == 'A')"
                            href="#"
                          >
                            <i class="fa fa-lock"></i>
                            Cerrar Operación
                          </button>
                          <button
                            class="dropdown-item"
                            @click="anular"
                            type="button"
                            :disabled="!(current.estado != '9')"
                            href="#"
                          >
                            <i class="fa fa-archive"></i>
                            Anular Operación
                          </button>
                          <div class="dropdown-divider"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </h5>
                <small
                  v-if="current.errors && current.errors.detail"
                  class="form-text text-danger"
                  >{{ current.errors.detail }}</small
                >
                <div class="row">
                  <div class="col-sm-3">
                    <TiendaSelectComponent titulo="Tienda" :current="current" />
                    <span style="color: #3aac24" class="form-text"
                      >¡Tienda a donde saldra el inventario!</span
                    >
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.tipo,
                        }"
                        >Tipo</label
                      >
                      <select
                        class="form-control"
                        autofocus="autofocus"
                        v-model="current.tipo_salida"
                        :disabled="current.estado == 'B'"
                      >
                        <option value="PROMO">PROMOCIÓN</option>
                        <option value="MAL_ESTADO">MAL ESTADO</option>
                        <option value="INSUMO">INSUMOS</option>
                      </select>
                      <small
                        v-if="current.errors && current.errors.tipo"
                        class="form-text text-danger"
                        >{{ current.errors.tipo[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-3">
                    <label>Comentario</label>
                    <textarea
                      :disabled="current.estado != 'A'"
                      class="form-control"
                      v-model="current.comentario"
                      rows="2"
                    ></textarea>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.fecha,
                        }"
                        >Fecha</label
                      >
                      <input
                        v-model="current.fecha"
                        class="form-control"
                        placeholder="Fecha"
                        :disabled="true"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.fecha"
                        class="form-text text-danger"
                        >{{ current.errors.fecha[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label>Usuario</label>
                      <input
                        :disabled="true"
                        class="form-control"
                        v-model="current.usuario"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <br />
                  <button
                    type="button"
                    class="btn btn-sm btn-dark btn-block"
                    @click="showModalAddDetail"
                    v-if="current.estado == 'A' && current.id"
                  >
                    <i class="fa fa-plus"></i>
                    Agregar Producto
                  </button>
                </div>
                <br />
                <div class="table-responsive" v-if="current.id != null">
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>SKU</th>
                        <th>Producto</th>
                        <th class="text-center">Unidad Medida</th>
                        <th class="text-center">Cantidad UM</th>
                        <th class="text-center">Unidades</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="detalle in current.salidainventariod_set"
                        v-bind:key="detalle.id"
                      >
                        <td>
                          <!--ProductoWithPopoverComponent :producto="detalle.producto" /-->
                          {{ detalle.producto.sku }}
                        </td>
                        <td>{{ detalle.producto.nombre }}</td>
                        <td>
                          {{ detalle.unidad_medida.nombre }}
                        </td>
                        <td
                          class="text-right bolder nowrap"
                          style="font-weight: 500"
                        >
                          <span class="text-success"
                            >+ {{ detalle.cantidad_um }}</span
                          >
                        </td>
                        <td
                          class="text-right bolder nowrap"
                          style="font-weight: 500"
                        >
                          <span class="text-success"
                            >+ {{ detalle.cantidad }}</span
                          >
                        </td>
                        <td
                          class="text-center"
                          style="width: 200px"
                        >
                          <button
                            class="btn btn-sm btn-danger mr-1"
                            type="button"
                            :disabled="current.estado == 'B'"
                            @click="deleteDetalle(detalle)"
                          >
                            <i class="fa fa-trash"></i>
                            Eliminar
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-------------------- END - Basic Table -------------------->
                </div>
                <div class="form-buttons-w">
                  <button
                    class="btn btn-md btn-success"
                    v-if="current.estado == 'A'"
                    type="submit"
                  >
                    Guardar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddDetatalle"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Agregar Producto</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          currentDetalle.errors &&
                          currentDetalle.errors.length > 0,
                      }"
                    ></label>
                    <ProductoSelectComponentV2
                      @onChangeProducto="onChangeProducto"
                      :current="currentDetalle"
                    ></ProductoSelectComponentV2>
                    <small
                      v-if="currentDetalle.errors"
                      class="form-text text-danger"
                      >{{ currentDetalle.errors.detail }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-12">
                  <ProductoUnidadMedidaSelectComponent
                    :current="currentDetalle.producto"
                  />
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          currentDetalle.errors.cantidad_um &&
                          currentDetalle.errors.cantidad_um.length > 0,
                      }"
                      >Cantidad</label
                    >
                    <input
                      v-model="currentDetalle.cantidad_um"
                      class="form-control"
                      placeholder="Cantidad"
                      type="text"
                      style="text-align: center; font-size: 200%"
                      v-bind:class="{
                        'is-invalid':
                          currentDetalle.errors.cantidad_um &&
                          currentDetalle.errors.cantidad_um.length > 0,
                      }"
                    />
                    <small
                      v-if="
                        currentDetalle.errors &&
                        currentDetalle.errors.cantidad_um
                      "
                      class="form-text text-danger"
                      >{{ currentDetalle.errors.cantidad_um }}</small
                    >
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="agregaDetalle()">
              Agregar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductosService from "@/services/catalogos/ProductosService";
import ReqTrasladoService from "@/services/inventario/ReqTrasladoService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductoUnidadMedidaSelectComponent from "@/components/commons/ProductoUnidadMedidaSelectComponent";
import ProductoWithPopoverComponent from "@/components/commons/ProductoWithPopoverComponent";
import DynamicService from "@/services/commons/DynamicService";
import SalidaTrasladoService from "@/services/inventario/SalidaTrasladoService";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";

export default {
  components: {
    TiendaSelectComponent,
    ProductoUnidadMedidaSelectComponent,
    ProductoWithPopoverComponent,
    ProductoSelectComponentV2,
  },
  data() {
    return {
      current: {
        estado_str: "",
        tienda: null,
        fecha: "",
        estado: "A",
        tipo_salida: "",
        errors: {},
        salidainventariod_set: [],
      },
      unidades_medidas: [],
      productos: [],
      currentDetalle: {
        cantidad: 0,
        producto: {
          sku: null,
          unidad_medida: null,
          errors: [],
        },
        errors: [],
      },
    };
  },
  computed: {},
  mounted() {
    let self = this;
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
  },
  methods: {
    refreshCurrent() {
      let self = this;
      DynamicService.getById(
        "inv",
        "sal_inventario",
        this.$route.params.id
      ).then((response) => {
        self.current = response.data;
        self.current.tienda = response.data.tienda.codigo;
        self.current.usuario = response.data.usuario.username;
        self.current = response.data;
      });
    },
    refreshUnidadMedida(producto) {
      let self = this;
      ProductosService.getById(producto.sku).then((response) => {
        self.currentDetalle.producto = response.data;
        self.currentDetalle.producto.unidad_medida =
          self.currentDetalle.producto.productounidadmedida_set[0];
        self.currentDetalle.producto.unidades_medidas =
          self.currentDetalle.producto.productounidadmedida_set;
        self.currentDetalle.producto.unidad_medida =
          self.currentDetalle.producto.unidad_medida.unidad_medida.id;
      });
    },
    guardar(e) {
      e.preventDefault();
      let self = this;
      DynamicService.save("inv", "sal_inventario", self.current)
        .then((response) => {
          Notifications.alert.success(
            "Nueva salida de inventario",
            "Realizádo Exitosamente"
          );
          if (!self.$route.params.id) {
            self.$router.push({
              name: "inventario-salida_inventario-editar",
              params: { id: response.data.id },
            });
            self.refreshCurrent();
          }
        })
        .catch((error) => {
          self.current.errors = error.response.data;
          Notifications.alert.error(
            "Guardar Requisiciones",
            error.response.data.detail
          );
        });
    },

    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    onSearchProducto(search, loading) {
      loading(true);
      this.searchProducto(loading, search, this);
    },

    searchProducto: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      ProductosService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.productos = res.data;
        loading(false);
      });
    }, 350),
    showModalAddDetail() {
      let self = this;
      ProductosService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.productos = res.data.results;
        $("#modalAddDetatalle").modal();
      });
    },
    agregaDetalle() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      if (det.producto) {
        det.producto = det.producto.sku;
      }
      det.unidad_medida = self.currentDetalle.producto.unidad_medida;
      DynamicService.postAction(
        "inv",
        "sal_inventario",
        self.current.id,
        "agregar_detalle",
        det
      )
        .then((response) => {
          Notifications.alert.success(
            "Agregar detalle",
            "Se ha guardado la Información."
          );
          self.refreshCurrent();
          self.refreshDetalleDefault();
          self.$refs.cerrarModal.click();
        })
        .catch((error) => {
          self.currentDetalle.errors = error.response.data;
          Notifications.alert.error(
            "Agregar detalle",
            error.response.data.detail
          );
        });
    },
    deleteDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Eliminar",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          DynamicService.postAction(
            "inv",
            "sal_inventario",
            self.current.id,
            "eliminar_linea",
            {
              id: detalle.id.replace("-", ""),
            }
          )
            .then((response) => {
              Notifications.alert.success(
                "Eliminar",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
              Notifications.alert.error("Eliminar", error.response.data.detail);
            });
        }
      );
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Abrir transacción",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          DynamicService.postAction("inv", "", self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Abrir transacción",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Abrir Transaccion",
                  error.response.data.detail
                );
              } else {
                Notifications.alert.error(
                  "Abrir Transaccion",
                  error.response.data.salida_traslado_d
                );
              }
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Cerrar transacción",
        "Si cierra la requisicion no podra abrirla nuevamente",
        "Si cerrar",
        function () {
          DynamicService.postAction(
            "inv",
            "sal_inventario",
            self.current.id,
            "cerrar"
          )
            .then((response) => {
              Notifications.alert.success(
                "Cerrar transacción",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Anular transacción",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          DynamicService.postAction(
            "inv",
            "sal_inventario",
            self.current.id,
            "anular"
          )
            .then((response) => {
              Notifications.alert.success(
                "Anular transacción",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.detail
                );
              } else {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.salida_traslado_d
                );
              }
            });
        }
      );
    },
    onChangeProducto(producto) {
      let self = this;
      self.refreshUnidadMedida(producto);
    },
    refreshDetalleDefault() {
      let self = this;
      self.currentDetalle = {
        cantidad: "",
        cantidad_um: "",
        unidad_medida: null,
        proveedor: null,
        producto: {
          sku: null,
          unidad_medida: null,
          errors: [],
        },
        a_pedir: null,
        errors: [],
      };
    },
    imprimir() {
      let op
      op = this.$route.params.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open (
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=inventario/salidas_inventario/salidas_inventario_detalle.jrxml&salida_id=${op}`
      );
    },
  },
};
</script>
